import {
  Component,
  Input,
  ChangeDetectionStrategy,
  HostBinding,
} from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'g [prChartedItemsMissingSurfacesBadge]',
  templateUrl: './charted-items-missing-surfaces-badge.component.html',
  styleUrls: ['./charted-items-missing-surfaces-badge.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class ChartedItemsMissingSurfacesBadgeComponent {
  @Input() count = 0;

  @HostBinding('style.r')
  @Input()
  radius = 32;
}
